import React from 'react';
import { Switch, Route } from 'react-router-dom';

import renderIfNotAuthenticated from 'hoc/renderIfNotAuthenticated';

import ToolList from './containers/ToolList';
import ToolForm from './containers/ToolForm';
import ToolView from './containers/ToolView';

const ToolRoutes = () =>
  <Switch>
    <Route path="/tools" component={ToolList} exact />
    <Route path="/tool/add" component={renderIfNotAuthenticated(ToolForm)} />
    <Route
      path="/tool/:toolName"
      render={({ match = { params: {} } }) =>
        <ToolView slug={match.params.toolName} />}
    />
  </Switch>;

export default ToolRoutes;



// WEBPACK FOOTER //
// ./src/App/Tool/Routes.js